import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useRef } from 'react';
import { useSelectedObjects } from '../../../hooks/useSelectedObjects';
import { ContextQueryModal } from '../../factories/ContextQuery/contextQueryModalV2';
import { getDataGridProps } from '../../NetworkSystem/NetworkMonitoriingTableView/selection/getDeviceSelectionDataGridProps';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const contextQueryModalV2Widget = () => {
    const parentTableUseSelectedObjects = useSelectedObjects();
    const lastSearchedItemsRef = useRef([]);
    const lastQueryComponentKeyRef = useRef(undefined);
    const lastQueryParamsRef = useRef(undefined);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "ContextQueryModal" }), _jsx(ContextQueryModal, { componentParamPairsMap: {}, getDataGridProps: getDataGridProps, parentTableUseSelectedObjects: parentTableUseSelectedObjects, lastSearchedItemsRef: lastSearchedItemsRef, lastQueryComponentKeyRef: lastQueryComponentKeyRef, lastQueryParamsRef: lastQueryParamsRef })] })), []);
    return {
        name: 'contextQueryModalV2',
        category: 'composite',
        component,
    };
};
